import { Slice, slices } from "../types";

export const generateTrack = (repeatCount: number, customSlices?: Slice[]): Slice[] => {
  const slicesToUse = customSlices || slices;
  let track: Slice[] = [];
  for (let i = 0; i < repeatCount; i++) {
    track = track.concat(slicesToUse);
  }
  return track;
};
